import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class JellyFish extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,type, ind) {
    super(scene);

    this.type = type;
    this.ind = ind;

    this.backLegs = null;
    this.frontLegs = null;
    this.head = null;

    this.tweenB = null;
    this.tweenF = null;
    this.tweenH = null;
    this.tweenJ = null;

    this.dir = { leftRight: null, upDown: null };

    this.jellyParts = [];

    this.setup();
  }

  setup () {
    if (this.ind === 1) this.setPosition(-50, Phaser.Math.Between(0, this.scene.scale.height / 2 + this.scene.scale.height / 4));
    else if (this.ind === 2) this.setPosition(Phaser.Math.Between(0, this.scene.scale.width / 2), -200);
    else if (this.ind === 3) this.setPosition(Phaser.Math.Between(this.scene.scale.width / 2, this.scene.scale.width), -200);
    else if (this.ind === 5) this.setPosition(this.scene.scale.width + 50, Phaser.Math.Between(0, this.scene.scale.height + this.scene.scale.height / 4));

    if (this.type === 1) this.createJelly1();
    if (this.type === 2) this.createJelly2();

    this.moveLegs(this.jellyParts[0]);
    this.moveLegs(this.jellyParts[1]);
    this.moveHead(this.jellyParts[2]);
    this.moveJelly();
  }

  createJelly1 () {
    this.backLegs = ABCyaPhaser.Images.addImage(0, 20, `Jelly0${this.ind}_BG`, this).setOrigin(0.5, 0);
    this.head = ABCyaPhaser.Images.addImage(0, 18, `Jelly0${this.ind}_FG`, this).setOrigin(0.5, 0.2);
    this.frontLegs = ABCyaPhaser.Images.addImage(0, 0, `Jelly0${this.ind}_MG`,this).setOrigin(0.5, 0);

    this.jellyParts.push(this.backLegs, this.frontLegs, this.head);
  }

  createJelly2 () {
    this.backLegs = ABCyaPhaser.Images.addImage(0, 23, `Jelly0${this.ind}_BG`, this).setOrigin(0.5, 0);
    this.head = ABCyaPhaser.Images.addImage(0, 28, `Jelly0${this.ind}_FG`, this).setOrigin(0.5, 1);
    this.frontLegs = ABCyaPhaser.Images.addImage(0, 5, `Jelly0${this.ind}_MG`, this).setOrigin(0.5, 0);

    this.jellyParts.push(this.backLegs, this.frontLegs, this.head);
  }

  moveLegs (obj) {
    const randX = Phaser.Math.FloatBetween(.75, 1);
    const randY = Phaser.Math.FloatBetween(.75, 1);
    const randTime = Phaser.Math.Between(2000, 6000);
    const randDel = Phaser.Math.Between(0, 1000);

    this.tweenB = ABCyaPhaser.Tweens.addTween(obj, randTime, { scaleX: randX, scaleY: randY, delay: randDel }, Phaser.Math.Easing.Sine.InOut, () => {
      this.moveLegs(obj);
    });
  }

  moveHead (obj) {
    const randX = Phaser.Math.FloatBetween(.8, 1);
    const randY = Phaser.Math.FloatBetween(.9, 1);
    const randTime = Phaser.Math.Between(2000, 6000);
    const randDel = Phaser.Math.Between(0, 2000);

    this.tweenH = ABCyaPhaser.Tweens.addTween(obj, randTime, { scaleX: randX, scaleY: randY, delay: randDel, yoyo: true },Phaser.Math.Easing.Sine.InOut, () => {
      this.moveHead(obj);
    });
  }

  moveJelly () {
    let newX;
    let newY;
    let dip;
    let newAng;
    const randTime = Phaser.Math.Between(5000, 10000);
    const randDel = Phaser.Math.Between(0, 2000);

    this.setDirection();

    if (this.dir.leftRight === 'right') {
      newX = Phaser.Math.Between(0, 100);
      newAng = Phaser.Math.Between(5, 10);
    }
    else if (this.dir.leftRight === 'left') {
      newX = Phaser.Math.Between(-100, 0);
      newAng = Phaser.Math.Between(-10, -5);
    }

    if (this.dir.upDown === 'up') {
      newY = Phaser.Math.Between(-100, 0);
      dip = Phaser.Math.Between(0, 25);
    }
    else if (this.dir.upDown === 'down') {
      newY = Phaser.Math.Between(-25, 0);
      dip = Phaser.Math.Between(0, 100);
    }

    this.tweenJ = ABCyaPhaser.Tweens.addTween(this, randTime, { x: this.x + newX, delay: randDel }, Phaser.Math.Easing.Sine.InOut);
    this.tweenJ = ABCyaPhaser.Tweens.addTween(this, randTime / 2, { y: this.y + newY, angle: newAng, delay: randDel }, Phaser.Math.Easing.Sine.In);
    this.tweenJ = ABCyaPhaser.Tweens.addTween(this, randTime / 2, { y: this.y + newY + dip, angle: 0, delay: randDel + (randTime / 2) }, Phaser.Math.Easing.Sine.Out, () => {
      this.moveJelly();
    });
  }

  setDirection () {
    if (this.x <= 200) {
      this.dir.leftRight = 'right';
    }
    else if (this.x >= 800) {
      this.dir.leftRight = 'left';
    }
    else if (this.x > 200 && this.x < 800) {
      const randLeftRight = Phaser.Math.Between(1, 2);
      if (randLeftRight === 1) {
        this.dir.leftRight = 'right';
      }
      else {
        this.dir.leftRight = 'left';
      }
    }

    if (this.y <= 0) {
      this.dir.upDown = 'down';
    }
    else if (this.y >= this.scene.scale.height / 2) {
      this.dir.upDown = 'up';
    }
    else if (this.y > 0 && this.y < this.scene.scale.height / 2) {
      const randUpDown = Phaser.Math.Between(1, 2);
      if (randUpDown === 1) {
        this.dir.upDown = 'up';
      }
      else {
        this.dir.upDown = 'down';
      }
    }
  }

  cleanUp () {
    this.scene.tweens.killTweensOf(this.backLegs);
    this.scene.tweens.killTweensOf(this.frontLegs);
    this.scene.tweens.killTweensOf(this.head);
    this.scene.tweens.killTweensOf(this);

    this.tweenB?.stop();
    this.tweenH?.stop();
    this.tweenJ?.stop();

    this.backLegs.destroy();
    this.frontLegs.destroy();
    this.head.destroy();
  }
}